/* Private reference gallery only: no checkout, tracking, or subscription code. */
(()=>{
  function init(){
    const root=document.getElementById('ybs-balm-reference');
    if(!root||root.dataset.ybsReady)return;
    root.dataset.ybsReady='true';
    const slides=[...root.querySelectorAll('[data-ybs-slide]')];
    const thumbs=[...root.querySelectorAll('[data-ybs-index]')];
    let active=0;
    function show(index){
      active=(index+slides.length)%slides.length;
      slides.forEach((s,i)=>{s.hidden=i!==active;s.setAttribute('aria-hidden',String(i!==active));s.classList.toggle('is-active',i===active)});
      thumbs.forEach((t,i)=>t.setAttribute('aria-current',String(i===active)));
      const track=root.querySelector('.product-gallery__thumbs');
      const thumb=thumbs[active];
      if(track&&thumb){
        if(matchMedia('(max-width:1000px)').matches)track.scrollLeft=Math.max(0,thumb.offsetLeft-track.offsetLeft-20);
        else track.scrollTop=Math.max(0,thumb.offsetTop-track.offsetTop-20);
      }
    }
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
    root.querySelector('[data-ybs-prev]')?.addEventListener('click',()=>show(active-1));
    root.querySelector('[data-ybs-next]')?.addEventListener('click',()=>show(active+1));
    const viewport=root.querySelector('.product-gallery__viewport');
    viewport?.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(active+1)}if(e.key==='ArrowLeft'){e.preventDefault();show(active-1)}});
    let start=null;
    viewport?.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});
    viewport?.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))show(active+(dx<0?1:-1));start=null},{passive:true});
    show(0);
  }
  init();document.addEventListener('shopify:section:load',init);
})();
